import { useContext } from "react";
import "./style.css"
import { SettingContext } from "src/context/settings";
export const SubMenu = () => {
    // const [subMenu, setSubMenu] = useState([
    //     { url: 'https://zalocloud.freshdesk.com/support/tickets/new', name: 'Liên hệ hỗ trợ' },
    //     { url: 'https://zalo.cloud/zns/guidelines/intro', name: 'Hướng dẫn cơ bản' },
    //     { url: 'https://zalo.cloud/zns/pricing', name: 'Bảng giá' },
    //     // { url: 'https://account.zalo.cloud/tool/sendSample', name: 'Gửi thử mẫu ZNS' },
    //     // { url: 'https://zalo.cloud/zns/guidelines/handle-error-code', name: 'Cách xử lý mã lỗi' },
    //     // { url: 'https://zalo.cloud/blog/thiet-lap-muc-dich-gui-khi-tao-mau-zns/erug88djjgrd9r7zzj', name: 'Phân biệt mục đích' },
    //     // { url: 'https://zalo.cloud/blog/co-che-danh-gia-chat-luong-va-quyen-loi-gui-zns/RZU6K97E8VKBNMEREG', name: 'Cơ chế đánh giá chất lượng' },
    // ])

    const { settings } = useContext(SettingContext);

    const styles = {
        container: {
            position: 'absolute',
            bottom: '55px',
            left: '12px',
            fontSize: '12px',
            fontWeight: '600',
            width: "93%",
        },
        list: {
            padding: '5px 0',
            listStyleType: 'None',
            display: 'flex',
            gap: '7px',
            overflowX: 'hidden',
            whiteSpace: 'nowrap',
            width: '100%',
            margin: '4px 0 4px 0',
            scrollbarWidth: 'none',  // For Firefox
            msOverflowStyle: 'none',  // For IE and Edge
            '&::WebkitScrollbar': {
                display: 'none',  // For Chrome, Safari and Opera
            },
            // cursor: 'grab',
        },
        listItem: {
            backgroundColor: 'white',
            borderRadius: '20px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            padding: '5px 16px',
            cursor: 'pointer',
            marginLeft: '5px',
            letterSpacing: 'normal'
        },
    }

    const openDoc = (url) => {
        window.open(url);
    };

    let isDown = false;
    let startX;
    let scrollLeft;

    const onMouseDown = (e) => {
        isDown = true;
        startX = e.pageX - e.currentTarget.offsetLeft;
        scrollLeft = e.currentTarget.scrollLeft;
        // setIsGrabbing(true);
    };

    const onMouseLeave = () => {
        isDown = false;
    };

    const onMouseUp = () => {
        isDown = false;
        // setIsGrabbing(false);
    };

    const onMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - e.currentTarget.offsetLeft;
        const walk = (x - startX);
        e.currentTarget.scrollLeft = scrollLeft - walk;
    };

    return (
        <div style={styles.container}>
            <ul style={styles.list}
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}
            >
                {settings.subMenu.map((item, index) => (
                    <li style={styles.listItem} key={index} onClick={() => openDoc(item.url)}>
                        <div>{item.name}</div>
                    </li>
                ))}
            </ul>
        </div>
    )
};